import { Container, Divider, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { ReviewReportSkeleton, ErrorMessage } from "./components";
import { generateReportDataFromResponse } from "./utils";
import { useParams } from "react-router";
import FlexBox from "../../components/layouts/Flexbox";
import { TypeformQuestionResponse } from "../../components/review-report-graphs";
import { fetchReviewReportDetails } from "../../api/typeform";
import { useMutationWithDispatch } from "../../hooks/useMutationWithDispatch";
import { APP_FONT_FAMILIES } from "../../enums";

export default function ReviewReport() {
  const [response, setResponse]: any = React.useState([]);
  const param: any = useParams();
  const {
    mutate: fetchReport,
    data: reportData,
    isPending: fetching,
    error: serverError,
  } = useMutationWithDispatch(fetchReviewReportDetails, {
    showErrorToast: true,
    onSuccess: (response) => {
      setResponse(response?.data);
    },
  });

  useEffect(() => {
    fetchReportData();
  }, []);

  const fetchReportData = async () => {
    const payload =
      param?.id === "all" ? { reportId: "all" } : { reportId: param?.id };

    fetchReport(payload);
  };

  if (fetching) {
    return (
      <Container sx={{ py: 2 }}>
        <ReviewReportSkeleton />
      </Container>
    );
  }

  if (serverError) {
    return (
      <Container sx={{ py: 2 }}>
        <ErrorMessage />
      </Container>
    );
  }

  const reviewReportData = generateReportDataFromResponse(reportData?.data);

  return (
    <Container sx={{ py: 2 }}>
      <FlexBox
        mb={2}
        justifyContent={"space-between"}
        alignItems={"center"}
        gap={2}
      >
        <FlexBox flexDirection={"column"}>
          <Typography fontFamily={APP_FONT_FAMILIES.readexPro} variant="h4">
            {response?.clientName || "Vendor Review"}
            {response?.ambassadorName && <> : {response?.ambassadorName} </>}
          </Typography>
          <Typography
            color={"textSecondary"}
            variant="caption"
            fontFamily={APP_FONT_FAMILIES.readexPro}
          >
            {response?.totalAns} Responses
          </Typography>
        </FlexBox>
      </FlexBox>
      <Divider />
      {reviewReportData?.map((question, index) => (
        <React.Fragment key={`typeform-question-report-${index}`}>
          <TypeformQuestionResponse
            question={question.question}
            totalResponses={question.totalResponses}
            totalFeedbacks={question.totalFeedbacks}
            type={question.type}
            data={question.data}
          />
          <Divider />
        </React.Fragment>
      ))}
    </Container>
  );
}
